// Modules
//import classNames from 'classnames/bind';
import { Slice } from '@utmb/types/slice-handler';
import { createRef, ReactElement, useEffect, useRef, useState } from 'react';
import SliceChronologyView from '@utmb/types/view/SliceChronologyView';

import styles from './chronology.module.scss';
import { Font } from '@utmb/design-system/text/font';
import { Spacer } from '@utmb/design-system/spacer/Spacer';
import { Mixed } from '@utmb/features/race/mixed/Mixed';
import { HorizontalAlignEnum } from '@utmb/types/index';
import variables from '@utmb/styles/common/common.module.scss';
import { useGlobal } from '@utmb/contexts/GlobalContext';

//const cx = classNames.bind(styles);

export const Chronology = (props: Slice<SliceChronologyView>): ReactElement | null => {
    const { items } = props;
    const {
        global: {
            event: { primaryColor, primaryColorIsDark, secondaryColor },
        },
    } = useGlobal();

    //const refs = items.map((item) => ({ section: `chronology${item.year}`, ref: useRef<HTMLDivElement>(null) })); // Does not pass linter
    const refs = useRef(items.map((item) => ({ section: `chronology${item.year}`, ref: createRef<HTMLDivElement>() })));
    const navRef = useRef<HTMLDivElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);

    const [visibleSection, setVisibleSection] = useState<string>();
    const [navOffsetTop, setNavOffsetTop] = useState<number>(0);

    const scrollTo = (id: string) => {
        document.getElementById(id)?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    };

    useEffect(() => {
        const handleScroll = () => {
            const bodyComputedStyle = getComputedStyle(document.body);
            const headerBarHeight = (parseFloat(bodyComputedStyle.getPropertyValue('--top-bar-height')) || 0) * parseInt(variables.basePixels);
            const menuHeight = (parseFloat(bodyComputedStyle.getPropertyValue('--menu-sticky-height')) || 0) * parseInt(variables.basePixels);
            const topBarHeight = document.getElementById('top-bar')?.clientHeight || 0;

            if (containerRef.current && navRef.current) {
                const dimContainer = containerRef.current.getBoundingClientRect();
                const dimNav = navRef.current.getBoundingClientRect();
                const relativeScrollPosition = dimContainer.top;
                const headerHeight = topBarHeight + menuHeight + headerBarHeight + 10;

                const myNavOffsetTop =
                    relativeScrollPosition > headerHeight
                        ? 0
                        : -relativeScrollPosition > dimContainer.height - dimNav.height - headerHeight
                        ? dimContainer.height - dimNav.height
                        : -relativeScrollPosition + headerHeight;
                setNavOffsetTop(myNavOffsetTop);

                const selected = refs.current.find(({ ref }) => {
                    const ele = ref.current;
                    if (ele) {
                        const dim = ele.getBoundingClientRect();
                        const offsetTop = ele.offsetTop;
                        const offsetBottom = offsetTop + dim.height;
                        return -relativeScrollPosition + headerHeight > offsetTop && -relativeScrollPosition + headerHeight < offsetBottom;
                    }
                });

                if (selected && selected.section !== visibleSection) {
                    setVisibleSection(selected.section);
                }
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [visibleSection]);

    return (
        <div
            className={[styles.container, primaryColorIsDark ? styles.isDark : null].filter(Boolean).join(' ')}
            ref={containerRef}
            style={{ backgroundColor: primaryColor, color: secondaryColor }}
        >
            <div className={styles.menuList} ref={navRef} style={{ top: navOffsetTop }}>
                <ul>
                    {items.map((item, idx) => (
                        <li key={`menuChrono${item.year}`} className={visibleSection === refs.current[idx].section ? styles.selected : ''}>
                            <a
                                href={`#chronology${item.year}`}
                                onClick={(event) => {
                                    event.preventDefault();
                                    scrollTo(`chronology${item.year}`);
                                    return false;
                                }}
                            >
                                {item.year}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="container">
                {items.map((item, idx) => (
                    <div key={`chronology${item.year}`} ref={refs.current[idx].ref}>
                        <a id={`chronology${item.year}`} className={styles.anchor}>
                            &nbsp;
                        </a>
                        <div id={`chronologyItem${item.year}`}>
                            <Font.FuturaMedium
                                className={[styles.title, item.mixedContent?.pictureAlign === HorizontalAlignEnum.LEFT ? styles.right : null]
                                    .filter(Boolean)
                                    .join(' ')}
                                as="h2"
                            >
                                {item.year}
                            </Font.FuturaMedium>
                            <Spacer></Spacer>
                            <Mixed {...item.mixedContent} isDark={primaryColorIsDark} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
